export default function matchServiceByUrl(url) {
  const matchedService = {
    name: '',
    data: []
  };
  const regExpYouTube =
    /(?:https?:\/\/)?(?:www\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[-a-zA-Z0-9_]{11,}(?!\S))\/)|(?:\S*v=|v\/)))([-a-zA-Z0-9_]{11,})/;
  const regExpVimeo =
    /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/;

  const matchedVimeo = url.match(regExpVimeo);
  const matchedYoutube = url.match(regExpYouTube);

  if (matchedVimeo) {
    matchedService.name = 'vimeo';
    matchedService.data = matchedVimeo;
  } else if (matchedYoutube) {
    matchedService.name = 'youtube';
    matchedService.data = matchedYoutube;
  }

  return matchedService;
}
